import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/layout/sidebar/lllustrations/logo-general-center-text.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-auto h-16",
  alt: "logo"
}, null, -1)
const _hoisted_2 = { class: "font-semibold text-black-lp-100 text-42px flex-1 text-center" }
const _hoisted_3 = { class: "w-400px flex flex-col gap-y-6 text-sm text-black-lp-300" }
const _hoisted_4 = { class: "flex flex-col gap-y-3" }
const _hoisted_5 = { class: "font-montserrat font-semibold" }
const _hoisted_6 = { class: "inline-block relative w-full" }
const _hoisted_7 = { class: "flex flex-col gap-y-3" }
const _hoisted_8 = { class: "font-montserrat font-semibold" }
const _hoisted_9 = { class: "inline-block relative w-full" }
const _hoisted_10 = { class: "flex flex-col gap-y-2" }
const _hoisted_11 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_12 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_13 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_14 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_15 = { class: "flex flex-row space-x-3 items-center" }
const _hoisted_16 = { class: "pt-10 w-full flex items-center justify-center relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_HelpCenter = _resolveComponent("HelpCenter")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("setupPassword.title")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.t("setupPassword.passwordLabel")), 1),
        _createVNode("div", _hoisted_6, [
          _withDirectives(_createVNode("input", {
            "data-testid": "auth-setup-password-input-password",
            type: _ctx.newPasswordType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPassword = $event)),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkPassword && _ctx.checkPassword(...args))),
            placeholder: _ctx.t('setupPassword.placeholderPassword'),
            class: "w-full h-10 pl-4 pr-12 border shadow focus:outline-none rounded-md"
          }, null, 40, ["type", "placeholder"]), [
            [_vModelDynamic, _ctx.newPassword]
          ]),
          _createVNode("button", {
            "data-testid": "auth-setup-password-button-toggle-password",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showNewPassword && _ctx.showNewPassword(...args))),
            class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-4 text-gray-500 focus:outline-none"
          }, [
            (_ctx.iconType === 'eye')
              ? (_openBlock(), _createBlock(_component_Icons, {
                  key: 0,
                  name: "eye",
                  class: "h-6 text-gray-lp-600"
                }))
              : (_openBlock(), _createBlock(_component_Icons, {
                  key: 1,
                  name: "invisible",
                  class: "h-6 text-gray-lp-600"
                }))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("p", _hoisted_8, _toDisplayString(_ctx.t("setupPassword.confirmPasswordLabel")), 1),
        _createVNode("div", _hoisted_9, [
          _withDirectives(_createVNode("input", {
            "data-testid": "auth-setup-password-input-confirm-password",
            type: _ctx.confirmPasswordType,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmPassword = $event)),
            onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkPassword && _ctx.checkPassword(...args))),
            placeholder: _ctx.t('setupPassword.placeholderConfirmPassword'),
            class: ["w-full h-10 pl-4 pr-12 border shadow focus:outline-none rounded-md", {
            'border-red-lp-100': _ctx.confirmPassword !== _ctx.newPassword
          }]
          }, null, 42, ["type", "placeholder"]), [
            [_vModelDynamic, _ctx.confirmPassword]
          ]),
          _createVNode("button", {
            "data-testid": "auth-setup-password-button-toggle-confirm-password",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showConfirmPassword && _ctx.showConfirmPassword(...args))),
            class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-4 text-gray-500 focus:outline-none"
          }, [
            (_ctx.iconTypeConfirm === 'eye')
              ? (_openBlock(), _createBlock(_component_Icons, {
                  key: 0,
                  name: "eye",
                  class: "h-6 text-gray-lp-600"
                }))
              : (_openBlock(), _createBlock(_component_Icons, {
                  key: 1,
                  name: "invisible",
                  class: "h-6 text-gray-lp-600"
                }))
          ])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          (_ctx.containsEightCharacters)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 0,
                name: "check-circle",
                class: "text-green-lp-1600"
              }))
            : _createCommentVNode("", true),
          (!_ctx.containsEightCharacters && _ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 1,
                name: "x-circle",
                class: "w-5 h-5 shrink-0 text-red-lp-400"
              }))
            : _createCommentVNode("", true),
          (!_ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 2,
                name: "check-circle",
                class: "w-5 h-5 shrink-0 text-gray-lp-500"
              }))
            : _createCommentVNode("", true),
          _createVNode("p", null, _toDisplayString(_ctx.t("setupPassword.rules.eightChars")), 1)
        ]),
        _createVNode("div", _hoisted_12, [
          (_ctx.containsNumber)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 0,
                name: "check-circle",
                class: "text-green-lp-1600"
              }))
            : _createCommentVNode("", true),
          (!_ctx.containsNumber && _ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 1,
                name: "x-circle",
                class: "w-5 h-5 shrink-0 text-red-lp-400"
              }))
            : _createCommentVNode("", true),
          (!_ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 2,
                name: "check-circle",
                class: "w-5 h-5 shrink-0 text-gray-lp-500"
              }))
            : _createCommentVNode("", true),
          _createVNode("p", null, _toDisplayString(_ctx.t("setupPassword.rules.containsNumber")), 1)
        ]),
        _createVNode("div", _hoisted_13, [
          (_ctx.containsUppercase)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 0,
                name: "check-circle",
                class: "text-green-lp-1600"
              }))
            : _createCommentVNode("", true),
          (!_ctx.containsUppercase && _ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 1,
                name: "x-circle",
                class: "w-5 h-5 shrink-0 text-red-lp-400"
              }))
            : _createCommentVNode("", true),
          (!_ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 2,
                name: "check-circle",
                class: "w-5 h-5 shrink-0 text-gray-lp-500"
              }))
            : _createCommentVNode("", true),
          _createVNode("p", null, _toDisplayString(_ctx.t("setupPassword.rules.containsUppercase")), 1)
        ]),
        _createVNode("div", _hoisted_14, [
          (!_ctx.containsGenesis && _ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 0,
                name: "check-circle",
                class: "text-green-lp-1600"
              }))
            : _createCommentVNode("", true),
          (_ctx.containsGenesis)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 1,
                name: "x-circle",
                class: "w-5 h-5 shrink-0 text-red-lp-400"
              }))
            : _createCommentVNode("", true),
          (!_ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 2,
                name: "check-circle",
                class: "w-5 h-5 shrink-0 text-gray-lp-500"
              }))
            : _createCommentVNode("", true),
          _createVNode("p", null, _toDisplayString(_ctx.t("setupPassword.rules.noGenesis")), 1)
        ]),
        _createVNode("div", _hoisted_15, [
          (_ctx.confirmPassword && _ctx.confirmPassword === _ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 0,
                name: "check-circle",
                class: "text-green-lp-1600"
              }))
            : _createCommentVNode("", true),
          (_ctx.confirmPassword && _ctx.confirmPassword !== _ctx.newPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 1,
                name: "x-circle",
                class: "w-5 h-5 shrink-0 text-red-lp-400"
              }))
            : _createCommentVNode("", true),
          (!_ctx.confirmPassword)
            ? (_openBlock(), _createBlock(_component_Icons, {
                key: 2,
                name: "check-circle",
                class: "w-5 h-5 shrink-0 text-gray-lp-500"
              }))
            : _createCommentVNode("", true),
          _createVNode("p", null, _toDisplayString(_ctx.t("setupPassword.rules.passwordMatch")), 1)
        ])
      ]),
      _createVNode("button", {
        "data-testid": "auth-setup-password-button-submit",
        type: "submit",
        class: ["text-white py-2 font-bold rounded-md focus:outline-none w-full mt-5 shadow", {
        'bg-gray-lp-600 cursor-not-allowed': _ctx.disabled,
        'bg-red-lp-100 cursor-pointer': !_ctx.disabled
      }],
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSetupPassword && _ctx.onSetupPassword(...args))),
        disabled: _ctx.disabled
      }, _toDisplayString(_ctx.t("setupPassword.submitButton")), 11, ["disabled"])
    ]),
    _createVNode(_component_HelpCenter),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_Footer)
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          title: _ctx.modalData.title,
          message: _ctx.modalData.message,
          image: _ctx.modalData.image,
          textSuccess: _ctx.modalData.textSuccess,
          onSubmit: _ctx.modalData.onSubmit
        }, null, 8, ["title", "message", "image", "textSuccess", "onSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}